import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { Link, useParams } from 'react-router-dom';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import LoadingSpinner from '../../components/LoadingSpinner';

// TYPES
import { SafetyChecklistTemplateChecklistTemplate } from '../../api/models';
import { RouteParams } from '../../Interfaces';

const SafetyChecklistsTemplatePreview: React.FC = (props) => {
	const params = useParams<RouteParams>();

	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	const [templateType, setTemplateType] = React.useState<string>();

	// Set up Data state and Initial Data
	const initialState = {
		id: undefined,
		title: undefined,
		usage: undefined,
		checklistItems: []
	};

	const [safetyChecklistsTemplateItemsData, setSafetyChecklistsTemplateItemsData] =
		React.useState<SafetyChecklistTemplateChecklistTemplate>(initialState);

	const getSafetyChecklistsTemplateItemsData = async () => {
		setIsLoading(true);

		const checklistParams = async () => {
			if (params.id.startsWith('TemplateId=')) {
				setTemplateType('TemplateId');

				return await apibridge.getSafetyChecklistTemplate(params.id.split('=')[1], '');
			} else {
				setTemplateType('ChecklistId');

				return await apibridge.getSafetyChecklistTemplate(``, params.id.split('=')[1]);
			}
		};

		const response = await checklistParams();

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);

			setIsLoading(false);
		} else {
			const { result = {} } = response;

			setIsLoading(false);

			setSafetyChecklistsTemplateItemsData(result);
		}
	};

	React.useEffect(() => {
		getSafetyChecklistsTemplateItemsData();
	}, []);

	const { id, title, usage, checklistItems } = safetyChecklistsTemplateItemsData;

	return (
		<div className="page-general-layout">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<p className="sub-grey-text offset-top-30">Safety Checklist Templates</p>

								<h1 className="text-capitalized mbtom-40">{title}</h1>

								{usage ? (
									<>
										<h3 className="mbtom-16">Usage</h3>

										<p className="sub-grey-text mbtom-40">{usage}</p>
									</>
								) : null}

								<h3 className="mbtom-16">Checklist items</h3>

								<ul>
									{checklistItems &&
										checklistItems.length > 0 &&
										checklistItems.map((item, index) => {
											return (
												<li className="general-list-item with-list-type" key={index}>
													{item}
												</li>
											);
										})}
								</ul>

								<div className="single-btn-right-container">
									<Link
										className="btn-primary"
										to={{ pathname: `/create-checklist/${templateType}=${id}`, state: { fromTemplate: true } }}
									>
										Use this template
									</Link>
								</div>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default SafetyChecklistsTemplatePreview;
